import { render, staticRenderFns } from "./AdminChallenges.vue?vue&type=template&id=7681ffb1&"
import script from "./AdminChallenges.vue?vue&type=script&lang=js&"
export * from "./AdminChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports